import React, { memo } from 'react';
import moment from 'moment-timezone';
import type { MomentInput } from 'moment';

import { TestIds } from '../../../test-utils/tests.consts';
import { getIsSameDay } from '../utils';
import { DEFAULT_DATE_FORMAT } from '../../../consts';

interface Props {
	firstDate: MomentInput;
	secondDate: MomentInput;
	timezone: string;
	hoursFormat: string;
	dateFormat?: string;
}

export const formatDate = (date: MomentInput, dateFormat: string, timezone: string) =>
	timezone ? moment(date).tz(timezone).format(dateFormat) : moment(date).format(dateFormat);

export const FormattedTimeWindow = memo(
	({ firstDate, secondDate, timezone, hoursFormat, dateFormat = DEFAULT_DATE_FORMAT }: Props) => {
		const isSameDay = getIsSameDay(firstDate, secondDate, timezone);
		const fullFormat = `${hoursFormat}, ${dateFormat}`;
		const timeWindowStart = formatDate(firstDate, isSameDay ? hoursFormat : fullFormat, timezone);
		const timeWindowEnd = formatDate(secondDate, fullFormat, timezone);
		const formattedTimezone = timezone ? `(${timezone})` : '';

		const titleAttribute = `${timeWindowStart} - ${timeWindowEnd} ${formattedTimezone}`;

		return (
			<span title={titleAttribute} data-test-id={TestIds.FORMATTED_TIME_WINDOW}>
				{timeWindowStart} - {timeWindowEnd}
				{formattedTimezone && <span className="time-cell-timezone">{formattedTimezone}</span>}
			</span>
		);
	}
);
